import {LocalStorageWrapper} from "apollo3-cache-persist";

export const storage = new LocalStorageWrapper(window.localStorage);